<div class="page-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar pageTitle="Inferences" pageSubtitle="AI-generated business insights from your knowledge graph"></app-navbar>

    <div class="content">

      <app-pending-reviews-banner [refreshNote]="true"></app-pending-reviews-banner>

      <!-- Top bar -->
      <div class="top-bar">
        <div class="top-bar-left">
          <span class="result-count" *ngIf="hasGenerated()">
            {{ filtered().length }} inference{{ filtered().length !== 1 ? 's' : '' }} found
          </span>
        </div>
        <app-button variant="primary" size="sm" [disabled]="isGenerating()" (clicked)="openPicker()">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="margin-right:5px;vertical-align:middle">
            <polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          {{ isGenerating() ? 'Generating…' : hasGenerated() ? 'Sync documents' : 'Generate Inferences' }}
        </app-button>
      </div>

      <!-- Severity summary cards -->
      <div class="severity-cards" *ngIf="hasGenerated() && !isGenerating()">
        <div class="sev-card critical-card" [class.active-filter]="severityFilter()==='critical'" (click)="severityFilter.set(severityFilter()==='critical' ? 'all' : 'critical')">
          <span class="sev-icon critical-icon">
            <span class="sev-icon-glyph" [style.-webkit-mask-image]="'url(' + severityIcon('critical') + ')'" [style.mask-image]="'url(' + severityIcon('critical') + ')'" aria-hidden="true"></span>
          </span>
          <div class="sev-text">
            <span class="sev-label">Critical</span>
            <span class="sev-number">{{ counts().critical }}</span>
          </div>
        </div>
        <div class="sev-card high-card" [class.active-filter]="severityFilter()==='high'" (click)="severityFilter.set(severityFilter()==='high' ? 'all' : 'high')">
          <span class="sev-icon high-icon">
            <span class="sev-icon-glyph" [style.-webkit-mask-image]="'url(' + severityIcon('high') + ')'" [style.mask-image]="'url(' + severityIcon('high') + ')'" aria-hidden="true"></span>
          </span>
          <div class="sev-text">
            <span class="sev-label">High</span>
            <span class="sev-number">{{ counts().high }}</span>
          </div>
        </div>
        <div class="sev-card medium-card" [class.active-filter]="severityFilter()==='medium'" (click)="severityFilter.set(severityFilter()==='medium' ? 'all' : 'medium')">
          <span class="sev-icon medium-icon">
            <span class="sev-icon-glyph" [style.-webkit-mask-image]="'url(' + severityIcon('medium') + ')'" [style.mask-image]="'url(' + severityIcon('medium') + ')'" aria-hidden="true"></span>
          </span>
          <div class="sev-text">
            <span class="sev-label">Medium</span>
            <span class="sev-number">{{ counts().medium }}</span>
          </div>
        </div>
        <div class="sev-card low-card" [class.active-filter]="severityFilter()==='low'" (click)="severityFilter.set(severityFilter()==='low' ? 'all' : 'low')">
          <span class="sev-icon low-icon">
            <span class="sev-icon-glyph" [style.-webkit-mask-image]="'url(' + severityIcon('low') + ')'" [style.mask-image]="'url(' + severityIcon('low') + ')'" aria-hidden="true"></span>
          </span>
          <div class="sev-text">
            <span class="sev-label">Low</span>
            <span class="sev-number">{{ counts().low }}</span>
          </div>
        </div>
      </div>

      <!-- Generating visualization -->
      <div class="generating-state" *ngIf="isGenerating()">
        <div class="gen-flow">
          <div class="gen-node">
            <div class="gen-node-icon gni-graph">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/>
              </svg>
            </div>
            <span class="gen-node-label">Knowledge Graph</span>
            <span class="gen-node-sub">Reading triples</span>
          </div>
          <div class="gen-connector">
            <span class="conn-dot"></span><span class="conn-dot"></span>
            <span class="conn-dot"></span><span class="conn-dot"></span>
          </div>
          <div class="gen-node">
            <div class="gen-node-icon gni-engine">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <rect x="5" y="8" width="14" height="12" rx="3"/>
                <circle cx="9" cy="13" r="1.5" fill="currentColor" stroke="none"/>
                <circle cx="15" cy="13" r="1.5" fill="currentColor" stroke="none"/>
                <path d="M9 18h6"/>
                <line x1="12" y1="5" x2="12" y2="8"/>
                <circle cx="12" cy="4" r="1.5" fill="currentColor" stroke="none"/>
              </svg>
            </div>
            <span class="gen-node-label">AI Engine</span>
            <span class="gen-node-sub">Analysing patterns</span>
          </div>
          <div class="gen-connector">
            <span class="conn-dot"></span><span class="conn-dot"></span>
            <span class="conn-dot"></span><span class="conn-dot"></span>
          </div>
          <div class="gen-node">
            <div class="gen-node-icon gni-output">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                <path d="M12 2a7 7 0 0 1 7 7c0 2.7-1.5 5-3.7 6.3V17a1 1 0 0 1-1 1h-4.6a1 1 0 0 1-1-1v-1.7C6.5 14 5 11.7 5 9a7 7 0 0 1 7-7z"/>
                <line x1="9.5" y1="21" x2="14.5" y2="21"/>
              </svg>
            </div>
            <span class="gen-node-label">Inferences</span>
            <span class="gen-node-sub">Generating insights</span>
          </div>
        </div>
        <p class="generating-text">Analysing knowledge graph and generating inferences…</p>
        <p class="generating-sub">This may take up to a minute depending on graph size.</p>
      </div>

      <!-- Empty / initial state -->
      <div class="empty-state" *ngIf="!isGenerating() && !hasGenerated()">
        <div class="empty-icon-wrap">
          <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#A855F7" stroke-width="1.5" stroke-linecap="round">
            <path d="M12 2a7 7 0 0 1 7 7c0 2.7-1.5 5-3.7 6.3V17a1 1 0 0 1-1 1h-4.6a1 1 0 0 1-1-1v-1.7C6.5 14 5 11.7 5 9a7 7 0 0 1 7-7z"/>
            <line x1="9.5" y1="21" x2="14.5" y2="21"/>
          </svg>
        </div>
        <p class="empty-title">No inferences yet</p>
        <p class="empty-sub">Select documents and click "Generate Inferences" to get AI-powered business insights from your knowledge graph.</p>
      </div>

      <!-- Main body: list + detail -->
      <div class="body-grid" *ngIf="!isGenerating() && hasGenerated()">

        <!-- Filter bar -->
        <h3 class="filters-heading">Filters</h3>
        <div class="filter-bar">
          <div class="filter-group">
            <label class="filter-label">Severity</label>
            <select class="filter-select" [value]="severityFilter()" (change)="severityFilter.set($any($event.target).value)">
              <option value="all">Select</option>
              <option value="critical">Critical</option>
              <option value="high">High</option>
              <option value="medium">Medium</option>
              <option value="low">Low</option>
            </select>
          </div>
          <div class="filter-group">
            <label class="filter-label">Inference Type</label>
            <select class="filter-select" [value]="typeFilter()" (change)="typeFilter.set($any($event.target).value)">
              <option value="all">Select</option>
              <option *ngFor="let t of inferenceTypes()" [value]="t">{{ t }}</option>
            </select>
          </div>
          <div class="filter-group">
            <label class="filter-label">Confidence</label>
            <select class="filter-select" [value]="confidenceFilter()" (change)="confidenceFilter.set($any($event.target).value)">
              <option value="all">Select</option>
              <option value="high">High (85%+)</option>
              <option value="med">Medium (70–85%)</option>
              <option value="low">Low (&lt;70%)</option>
            </select>
          </div>
          <div class="filter-group search-group">
            <div class="search-input-wrap">
              <svg class="search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input type="text" class="filter-input" placeholder="Search..."
                     [value]="searchQuery()" (input)="searchQuery.set($any($event.target).value)"/>
            </div>
          </div>
        </div>

        <!-- List + detail layout -->
        <div class="list-detail">

          <!-- Inference list -->
          <div class="inference-list">
            <div class="inf-card" *ngFor="let inf of filtered()"
                 [class.selected]="selected()?.topic === inf.topic"
                 (click)="selectInference(inf)">
              <div class="inf-card-main">
                <span class="inf-icon" [class]="'inf-icon-' + inf.severity">
                  <span class="sev-icon-glyph" [style.-webkit-mask-image]="'url(' + severityIcon(inf.severity) + ')'" [style.mask-image]="'url(' + severityIcon(inf.severity) + ')'" aria-hidden="true"></span>
                </span>
                <div class="inf-header-body">
                  <div class="inf-title-row">
                    <span class="sev-badge-solid" [class]="'badge-solid-' + inf.severity">{{ severityLabel(inf.severity) | uppercase }}</span>
                    <span class="inf-title">{{ inf.topic }}</span>
                  </div>
                  <p class="inf-body">{{ inf.inference }}</p>
                  <div class="fact-chips" *ngIf="factChips(inf).length">
                    <span class="fact-chip" *ngFor="let c of factChips(inf).slice(0,3)">{{ c }}</span>
                    <span class="fact-chip fact-chip-more" *ngIf="factChips(inf).length > 3">+{{ factChips(inf).length - 3 }}</span>
                  </div>
                </div>
              </div>
              <div class="inf-card-side">
                <span class="confidence-badge">Confidence {{ confidencePct(inf.confidence) }}%</span>
                <div class="side-meta">
                  <span class="side-meta-label">Type</span>
                  <span class="side-meta-value">{{ inf.inference_type }}</span>
                </div>
                <div class="side-meta" *ngIf="inf.supporting_facts?.length">
                  <span class="side-meta-label">Facts</span>
                  <span class="side-meta-value">{{ inf.supporting_facts.length }}</span>
                </div>
              </div>
            </div>

            <div class="empty-filtered" *ngIf="filtered().length === 0">
              <p>No inferences match your filters.</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Detail drawer -->
      <div class="drawer-backdrop" *ngIf="selected()" (click)="selected.set(null)"></div>
      <div class="detail-panel" *ngIf="selected() as inf">
        <div class="detail-header">
          <div class="detail-header-left">
            <button class="back-btn" (click)="selected.set(null)">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
            </button>
            <span class="detail-title-icon">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            </span>
            <span class="detail-title">Inference Details</span>
          </div>
          <button class="close-btn" (click)="selected.set(null)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
          </button>
        </div>

        <div class="detail-divider"></div>

        <div class="detail-body">
          <h2 class="detail-inf-title">{{ inf.topic }}</h2>
          <div class="detail-meta-line">
            <span class="meta-inline">{{ inf.inference_type | uppercase }}</span>
            <span class="meta-sep">·</span>
            <span class="meta-inline">{{ confidencePct(inf.confidence) }}% confidence</span>
            <ng-container *ngIf="inf.supporting_facts?.length">
              <span class="meta-sep">·</span>
              <span class="meta-inline">{{ inf.supporting_facts.length }} facts</span>
            </ng-container>
          </div>

          <h4 class="detail-section-title inference-label">Inference</h4>
          <p class="detail-inf-body">{{ inf.inference }}</p>

          <div class="detail-section" *ngIf="inf.recommended_action">
            <h4 class="detail-section-title">Recommended Action</h4>
            <div class="recommended-box">{{ inf.recommended_action }}</div>
          </div>

          <div class="detail-section" *ngIf="inf.supporting_facts?.length">
            <h4 class="detail-section-title">Supporting Facts</h4>
            <div class="fact-graph">
              <div class="fact-row" *ngFor="let f of inf.supporting_facts">
                <span class="fact-node src-node">{{ f.source }}</span>
                <span class="fact-edge">{{ f.relationship }}</span>
                <span class="fact-node tgt-node">{{ f.target }}</span>
              </div>
            </div>
          </div>

          <div class="detail-section" *ngIf="documentSourcesList(inf).length">
            <h4 class="detail-section-title">Document Sources</h4>
            <div class="doc-source-list">
              <div class="doc-source-row" *ngFor="let doc of documentSourcesList(inf).slice(0,3)">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                <span>{{ doc }}</span>
              </div>
            </div>
            <span class="more-docs-text" *ngIf="documentSourcesList(inf).length > 3">
              +{{ documentSourcesList(inf).length - 3 }} more documents
            </span>
          </div>
        </div>

        <div class="detail-actions">
          <button class="status-btn reject-btn"
                  [class.active]="statuses()[inf.topic] === 'rejected'"
                  (click)="setStatus(inf.topic, 'rejected')">
            Decline
          </button>
          <button class="status-btn accept-btn"
                  [class.active]="statuses()[inf.topic] === 'accepted'"
                  (click)="setStatus(inf.topic, 'accepted')">
            Approve
          </button>
        </div>
      </div>

    </div>
  </div>
</div>

<!-- Document picker modal -->
<div class="modal-backdrop" *ngIf="showPicker()" (click)="closePicker()">
  <div class="modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-header-left">
        <div class="modal-icon-wrap">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#475569" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
          </svg>
        </div>
        <div>
          <h3 class="modal-title">Select Documents</h3>
          <p class="modal-sub">Select specific documents or leave all unselected to use the full knowledge graph.</p>
        </div>
      </div>
      <button class="close-btn" (click)="closePicker()">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>
    <div class="modal-actions-row">
      <button class="link-btn" (click)="selectAll()">Select all</button>
      <button class="link-btn" (click)="clearAll()">Clear all</button>
      <span class="selection-count">{{ selectedDocNames().size }} selected</span>
    </div>
    <div class="doc-list" *ngIf="!loadingDocs()">
      <!-- SharePoint Documents -->
      <div class="doc-section" *ngIf="sharepointDocs().length > 0">
        <div class="doc-section-header">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#0078D4" stroke-width="2" stroke-linecap="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/></svg>
          <span>SharePoint Documents</span>
          <span class="doc-section-count">{{ sharepointDocs().length }}</span>
        </div>
        <label class="doc-item" *ngFor="let doc of sharepointDocs()">
          <input type="checkbox" [checked]="selectedDocNames().has(doc.name)" (change)="toggleDoc(doc.name)"/>
          <div class="doc-info">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
            <span class="doc-name">{{ doc.name }}</span>
          </div>
        </label>
      </div>

      <!-- Mailbox Emails -->
      <div class="doc-section" *ngIf="emailDocs().length > 0">
        <div class="doc-section-header">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#EA4335" stroke-width="2" stroke-linecap="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 8l10 7 10-7"/></svg>
          <span>Mailbox Emails</span>
          <span class="doc-section-count">{{ emailDocs().length }}</span>
        </div>
        <label class="doc-item" *ngFor="let doc of emailDocs()">
          <input type="checkbox" [checked]="selectedDocNames().has(doc.name)" (change)="toggleDoc(doc.name)"/>
          <div class="doc-info">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748B" stroke-width="2"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M2 8l10 7 10-7"/></svg>
            <span class="doc-name">{{ doc.name }}</span>
          </div>
        </label>
      </div>

      <p class="empty-docs" *ngIf="documents().length === 0">No documents found in the knowledge graph.</p>
    </div>
    <div class="doc-loading" *ngIf="loadingDocs()">Loading documents…</div>
    <div class="modal-footer">
      <app-button variant="secondary" size="sm" (clicked)="closePicker()">Cancel</app-button>
      <app-button variant="primary" size="sm" (clicked)="generate()">
        {{ selectedDocNames().size === 0 ? 'Use Full Graph' : 'Generate (' + selectedDocNames().size + ' docs)' }}
      </app-button>
    </div>
  </div>
</div>
